import { render } from "./ProjectDetail.vue?vue&type=template&id=0156c084&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=0156c084&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ecocomfort/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0156c084"]])

export default __exports__